module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('mu-divider', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "bottom": "10px",
      "margin": "auto"
    }
  }), _vm._v("   分割线\n")], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4d9ecc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/muse-ui/divider.vue
// module id = 574
// module chunks = 1